import { useState } from 'react';
import { InboxIcon } from '@heroicons/react/24/outline';
import { Panel } from '../../../../components/panels/Panel';
import { Modal } from '../../../../components/modals/Modal';
import {
  getVeralliaDashboardDefectLabel,
  sortVeralliaDashboardDetections,
} from '../../../../services/dashboard/verallia-dashboard-service';

export const VeralliaDashboardKpi = ({ label, value }) => {
  return (
    <Panel noHeader rounded category="secondary">
      <div className="flex flex-col gap-3">
        <div className="text-sm text-perception-gray-600">
          {label}
        </div>

        <div className="text-3xl text-perception-gray-300">
          {value}
        </div>
      </div>
    </Panel>
  );
};

export const VeralliaDashboardNoData = ({ text = 'No data' }) => {
  return (
    <div className="flex min-h-40 flex-col items-center justify-center gap-3 text-perception-gray-700">
      <InboxIcon className="size-12"/>
      <div className="text-sm">
        {text}
      </div>
    </div>
  );
};

export const VeralliaDashboardDetectionImage = ({
                                                  src,
                                                  alt,
                                                  className = '',
                                                }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`overflow-hidden rounded-md border border-perception-black-800 hover:border-perception-blue hover:ring-1 hover:ring-inset hover:ring-perception-blue ${className}`}
        onClick={() => setIsModalOpen(true)}
      >
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-cover"
        />
      </button>

      <Modal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        size="large"
        theme="dark"
      >
        <img
          src={src}
          alt={alt}
          className="max-h-[80vh] w-full rounded-md object-contain"
        />
      </Modal>
    </>
  );
};

export const VeralliaDashboardPictureWall = ({ detections, title = 'Shift picture wall' }) => {
  const sortedDetections = sortVeralliaDashboardDetections(detections);

  return (
    <Panel noHeader rounded category="secondary" overflowAuto={false} className="h-[420px]">
      <div className="mb-4 flex shrink-0 items-center justify-between">
        <div className="text-sm font-semibold uppercase text-perception-gray-400">{title}</div>
        <div className="text-xs text-perception-gray-600">{detections.length} captures</div>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto pr-1">
        {sortedDetections.length === 0 ? (
          <VeralliaDashboardNoData/>
        ) : (
          <div className="grid grid-cols-2 gap-3 xl:grid-cols-4 2xl:grid-cols-6">
            {sortedDetections.map((detection) => (
              <div key={detection.id} className="overflow-hidden rounded-md bg-perception-black-700">
                <VeralliaDashboardDetectionImage src={detection.image} alt={detection.palletId} className="aspect-video w-full"/>

                <div className="flex flex-col gap-1 p-2 text-xs">
                  <div className="font-medium text-perception-gray-300">{detection.palletId}</div>
                  <div className="text-perception-gray-600">
                    {detection.line} · {getVeralliaDashboardDefectLabel(detection.defect)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Panel>
  );
};